<template>
  <div class="w-full flex-1 justify-center">
		<div class="flex justify-start md:justify-center w-full mb-6">
			<DoiHeader :level="3" :fontFamily="1" class="text-2xl md:text-4xl tracking-wide">MES PAIEMENTS</DoiHeader>
		</div>
    <PaymentMeans />
    <PaymentHistory />
  </div>
</template>

<script>
import PaymentMeans from '@/views/reglements/PaymentMeans'
import PaymentHistory from '@/views/reglements/PaymentHistory'

export default {
  name: 'Reglements',
  components: {
    PaymentMeans,
    PaymentHistory
  },
  data () {
    return {
      paymentList: []
    }
  }
}
</script>

<style scoped>
.reglements-item {
  background-color: #f2f2f2;
}
</style>
